import { render, staticRenderFns } from "./billPreview.vue?vue&type=template&id=2f33d82a&"
import script from "./billPreview.vue?vue&type=script&lang=js&"
export * from "./billPreview.vue?vue&type=script&lang=js&"
import style0 from "./billPreview.vue?vue&type=style&index=0&id=2f33d82a&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports